const ExternalURL = {
  MORE_DETAILS: "https://support.google.com/chrome/answer/6130773",
};

export default ExternalURL;
